<template>
    <Link class="relative inline-flex items-center align-middle place-content-center" :as="as" :data="data" :href="href" :method="method" :replace="replace" :preserve-scroll="preserveScroll" :preserve-state="preserveState" :only="only" :headers="headers">
        <div v-show="!processing">
            <slot />
        </div>
        <div v-show="processing" class="absolute inset-0 flex items-center justify-center">
            <svg :class="[iconSize]" class="text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </Link>
</template>

<script>
export default {
    mounted() {
        let timeout = null

        this.$inertia.on("start", () => {
            timeout = setTimeout(() => (this.processing = true), 250)
        })

        // this.$inertia.on("progress", (event) => {
        //     if (NProgress.isStarted() && event.detail.progress.percentage) {
        //         NProgress.set((event.detail.progress.percentage / 100) * 0.9)
        //     }
        // })

        this.$inertia.on("finish", (event) => {
            clearTimeout(timeout)
            if (event.detail.visit.completed || event.detail.visit.interrupted || event.detail.visit.cancelled) {
                this.processing = false
            }
        })
    },
    props: {
        iconSize: {
            type: String,
            default: "w-6 h-6",
        },
        as: {
            type: String,
            default: "a",
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        href: {
            type: String,
            required: true,
        },
        method: {
            type: String,
            default: "get",
        },
        replace: {
            type: Boolean,
            default: false,
        },
        preserveScroll: {
            type: Boolean,
            default: false,
        },
        preserveState: {
            type: Boolean,
            default: null,
        },
        only: {
            type: Array,
            default: () => [],
        },
        headers: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            processing: false,
        }
    },
}
</script>
